import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { AddAccountComponent } from 'src/app/AddThings/add-account/add-account.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { TransactionHistoryComponent } from '../transaction-history/transaction-history.component';

@Component({
    selector: 'app-account-list',
    templateUrl: './account-list.component.html',
    styleUrls: ['./account-list.component.scss'],
    standalone: false
})
export class AccountListComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];

  // extrasTransactionList: Transaction[] = new Array;
  duitLebihBalance: number;

  loggedInRole: number;

  ngOnInit(): void {

    const companyId = Number(sessionStorage.getItem('companyId'));
    this.loggedInRole = Number(sessionStorage.getItem('roleId'));

    this.getAllAccountsOfCompany(companyId);

    if (this.loggedInRole == this.enums.BRANCH_MANAGER)
      this.getExtraBalance(companyId);
  }

  private getAllAccountsOfCompany(companyId: number) {

    const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {

          const amount = (json.balance == undefined) ? 0 : json.balance;
          const account = new Account(json.id, json.number, json.name, json.holderName, amount, json.companyId, json.username);

          if (account.Username != undefined)
            this.cashAccountList.push(account)
          else {
            this.companyBankAccountList.push(account);
          }

        }
        );

      }
    };
  }

  getExtraBalance(companyId: number) {

    const reduceASecDate = new Date(Number(new Date()) - 1);
    const endDateStr = reduceASecDate.toISOString();

    const xhttp = this.restApi.getRequest(this.constructApi.getCompanyTransactionBalances(companyId, endDateStr, this.enums.EXTRAS));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {

          const balance = Number(json.balance);
          this.duitLebihBalance = balance;
        }
        );

      }
    };
  }
  // getExtraBalance(companyId: number) {
  //   var xhttp = this.restApi.getRequest(this.constructApi.getExtraBalance(companyId));
  //   xhttp.onreadystatechange = () => {
  //     if (xhttp.readyState == 4 && xhttp.status == 200) {

  //       var json = JSON.parse((xhttp.responseText));
  //       // console.log(jsonArray);

  //       this.duitLebihBalance = json.balance;
  //     }
  //   };

  // }

  // calculateExtrasTotal() {
  //   var total = 0;
  //   for (let i = 0; i < this.extrasTransactionList.length; i++) {
  //     total += this.extrasTransactionList[i].Amount;
  //   }
  //   return total;
  // }

  openTransactionHistoryModal(accountId: number) {
    const modalRef = this.sharedService.openModal(TransactionHistoryComponent, "largeModal");
    modalRef.componentInstance.accountId = accountId;
  }

  // openDuitLebihTransactionModal() {
  //   const modalRef = this.sharedService.openModal(TransactionHistoryComponent, { windowClass: "largeModal" });
  //   modalRef.componentInstance.transactionList = this.extrasTransactionList;
  // }

  openAddAccountDialog() {
    const modalRef = this.sharedService.openModal(AddAccountComponent);
    //get account that was created
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const account = entry;

      //append added account to account list
      this.companyBankAccountList.push(account);
    });

    modalRef.result.then(() => {
      this.cdr.detectChanges();
    })

  }

}
